














































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import { required, email } from "vuelidate/lib/validators";
import { phone } from "@/validators/custom";
import { Address } from "@/models/address/address";
import countries from "@/models/form/data";
import { EventBus } from "@/event-bus";
import FormValidation from "@/components/elements/form/FormValidation.vue";
import states from "@/models/form/state-abbrv";
import provinces from "@/models/form/prov-abbrv";

@Component({
  components: {
    FormValidation
  }
})
export default class Billing extends Vue {
  @Prop() first_name!: string;
  @Prop() last_name!: string;
  @Prop() company_name!: string;
  @Prop() address!: Address;
  @Prop() phone!: string;
  @Prop() email!: string;
  protected countries = countries;
  // protected sameAsShipping = false;
  protected country = "";

  @Validations()
  validations() {
    return {
      first_name: { required },
      last_name: { required },
      company_name: { required },
      address: {
        address_1: { required },
        city: { required },
        state: {
          stateReq: value => {
            if (
              !value &&
              (this.address.country === "USA" ||
                this.address.country === "Canada")
            ) {
              return false;
            } else {
              return true;
            }
          }
        },
        postal_code: { required },
        country: { required }
      },
      phone: { required, phone },
      email: { required, email }
    };
  }

  beforeDestroy() {
    EventBus.$off("submitCheckoutForm");
  }

  @Watch("$v.$invalid", { deep: true })
  onFormChange(): void {
    this.validateForm();
  }

  @Watch("country")
  public updateCountry() {
    const newAddress = Object.assign(
      {},
      { ...this.address },
      { country: this.country }
    );
    this.$emit(`update:address`, newAddress);
    if (this.$v.address["country"]) {
      this.$v.address["country"]!.$touch();
    }
    if (this.country !== "USA" && this.country !== "Canada") {
      this.updateAddress({ state: "" }, "state");
    }
  }

  created() {
    EventBus.$on("submitCheckoutForm", this.validateForm);
    this.country = this.address.country ? this.address.country : "USA";
  }

  get zipMask(): string {
    let mask;
    if (this.country === "Canada") {
      mask = "A#A #A#";
    } else {
      mask = "#####";
    }
    return mask;
  }

  get states(): string[] {
    let list = ["--"];
    if (this.country === "Canada") {
      list = provinces;
    } else if (this.country === "USA") {
      list = states;
    }
    return list;
  }

  protected validateForm(): void {
    this.$v.$touch();
    this.$emit("sendError", this.$v.$invalid, "billing");
  }

  /**
   * Have to explicitly call vuelidate ($v) methods if not using v-model
   */
  public updateItem(fieldValue: string, fieldName: string) {
    this.$emit(`update:${fieldName}`, fieldValue);
    if (this.$v[fieldName]) {
      this.$v[fieldName]!.$touch();
      this.validateForm();
    }
  }

  /**
   * Cannot update a nested property in an object due to the way Vue tracks nested data
   * i.e. update:address.address_1 = value will not trigger reactivity, so use Object.assign{} and update entire address object
   */
  public updateAddress(newObj: any, fieldName: string) {
    const newAddress = Object.assign(
      {},
      { ...this.address, country: this.country },
      { ...newObj }
    );
    this.$emit(`update:address`, newAddress);
    if (this.$v.address[fieldName]) {
      this.$v.address[fieldName]!.$touch();
      this.validateForm();
    }
  }
}
